
namespace TabAurous.SalesOrder{

    @Serenity.Decorators.registerClass()
    export class OrderItemsGrid extends _Ext.GridBase<SalesOrderItemsRow, any> {
        protected getColumnsKey() { return 'SalesOrder.SalesOrderSelectItems'; }
        protected getDialogType() { return SalesOrderItemsDialog; }
        protected getIdProperty() { return SalesOrderItemsRow.idProperty; }
        protected getInsertPermission() { return SalesOrderItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesOrderItemsRow.localTextPrefix; }
        protected getService() { return OrderItemsForSalesService.baseUrl; }

        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {};
        public rowSelection: Serenity.GridRowSelectionMixin;
        withBom: boolean; 
        //withBom: boolean;
        constructor(container: JQuery,options) {
            super(container,options);

            (this.view.params as TransactionRequest).PartyId = options.GridFilters.PartyId;
            (this.view.params as TransactionRequest).InStock = options.GridFilters.InStock;
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        } 
        get selectedItems(): SalesOrderItemsRow[] {
            var _this = this; 
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }
          
        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }

    } 
}